import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { switchLanguage, dismissEmailAlert } from '../actions/session'
import App from '../common/app'
import Profile from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="profile" {...getState()} {...appActions}>
      <Profile
        {...getState()}
        {...appActions}
        switchLanguage={switchLanguage}
        dismissEmailAlert={dismissEmailAlert}
      />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
